import { defineStore } from "pinia";
import api from "@/plugins/axios"

export const useApiPingStore = defineStore('api-ping', {
    state: () => ({
        items: {
            data: [],
            pagination: {
                page: 1,
                limit: 10,
                total: 0,
                totalPages: 0
            }
        },
        item: {}
    }),
    actions: {
        async getList(page = 1, limit = 10) {
            try {
                const { data } = await api.get(`api-ping`, {
                    params: { page, limit }
                });
                this.items = data;
            } catch (error) {
                console.error(error);
                this.items = {
                    data: [],
                    pagination: {
                        page: 1,
                        limit: 10,
                        total: 0,
                        totalPages: 0
                    }
                };
            }
        },
        async create(item) {
            try {
                const { data } = await api.post(`api-ping`, item);
                return data;
            } catch (error) {
                console.error('Error creating:', error);
                throw error;
            }
        },
        async delete(id) {
            try {
                await api.delete(`api-ping/${id}`);
            } catch (error) {
                console.error('Error deleting:', error);
                throw error;
            }
        },
    }
});